module.exports = __webpack_public_path__ + "static/images/containers/PostbattleScreen/components/FortBattleSeries/images/stronghold-red-current.3dc21f92.png";


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/components/FortBattleSeries/images/stronghold-red-current.png
// module id = 3230
// module chunks = 11